import { type ReactElement } from "react"
import { ListIcon } from "lucide-react"

import { Button } from "@/components/ui/shadcn/button"
import {
  Popover,
  PopoverContent,
  PopoverTitle,
  PopoverTrigger,
} from "@/components/ui/shadcn/popover"
import type { Category } from "@/types/product"

import { CatalogMenuContent } from "./CatalogMenuContent"
import { useCatalogMenuState } from "./useCatalogMenuState"

type CatalogMenuDesktopProps = {
  categories: Category[]
  trigger?: ReactElement
}

export const CatalogMenuDesktop = ({ categories, trigger }: CatalogMenuDesktopProps) => {
  const catalogState = useCatalogMenuState(categories)

  return (
    <Popover open={catalogState.open} onOpenChange={catalogState.handleOpenChange}>
      <PopoverTrigger
        render={
          trigger ?? (
            <Button size="lg" className="min-w-[148px]">
              <ListIcon data-icon="inline-start" />
              Каталог
            </Button>
          )
        }
      />
      <PopoverContent
        align="start"
        sideOffset={14}
        className="h-[548px] w-[880px] max-w-[calc(100vw-48px)] overflow-hidden p-0 [box-shadow:0_32px_72px_-24px_rgba(17,24,39,0.34),0_12px_28px_-18px_rgba(56,49,129,0.38),inset_0_1px_0_rgba(255,255,255,0.9)]"
        data-scaena-ui
      >
        <PopoverTitle className="sr-only">Каталог</PopoverTitle>
        <CatalogMenuContent
          categories={categories}
          activeCategory={catalogState.activeCategory}
          isLoading={catalogState.isLoading}
          isError={catalogState.isError}
          onRetry={catalogState.loadCategories}
          onActivateCategory={catalogState.setActiveCategory}
          onNavigate={() => catalogState.setOpen(false)}
        />
      </PopoverContent>
    </Popover>
  )
}
